export default __webpack_public_path__ + "static/media/darwinlogo.b988bfe3.png";